import { render, staticRenderFns } from "./FornecedoresForm.vue?vue&type=template&id=de4ffb30&scoped=true&"
import script from "./FornecedoresForm.vue?vue&type=script&lang=js&"
export * from "./FornecedoresForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4ffb30",
  null
  
)

export default component.exports